export const progressCourseQuery = `query progressCourse($uid: Int!, $careerId: Int!){
  CourseTrail{
    item(careerId: $careerId){
      id
      courses{
        items{
          progress(uid: $uid)
          post{
            title
            workspace{
              name
              id
            }
          }
        }
      }
    }
  }
}
`;
